import { create } from 'zustand';

interface SyncHostTimezoneState {
  isSyncHostTimezoneSelected: boolean;
}

const initSyncHostTimezone: SyncHostTimezoneState = {
  isSyncHostTimezoneSelected: false,
};

interface SyncHostTimezoneAction {
  toggleSyncHostTimezoneSelected: (selected: boolean) => void;
  reset: () => void;
}

export const useSyncHostTimezoneStore = create<SyncHostTimezoneState & SyncHostTimezoneAction>()(
  (set) => ({
    ...initSyncHostTimezone,
    toggleSyncHostTimezoneSelected: (selected: boolean) =>
      set({ isSyncHostTimezoneSelected: selected }),
    reset: () => set(initSyncHostTimezone),
  }),
);
